import { CssBaseline } from '@mui/material'
import i18next from 'i18next'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import App from './App'
import { AppProvider } from './hooks/useApp'
import './utils/error-handler'
import './index.css'

import en from './lang/en.json'
import fi from './lang/fi.json'
import { Safety } from './classes/Safety'
import { ThemeProvider } from './providers/ThemeProvider'
import { adoptSessionForNewBuild } from './utils/new-build'

const resources = {
  en: {
    translations: en
  },
  fi: {
    translations: fi
  }
}

i18next.init({
  resources,

  fallbackLng: 'en',
  debug: false,

  ns: ['translations'],
  defaultNS: 'translations',

  keySeparator: false,
  nsSeparator: 'NS_NOT_IN_USE',

  interpolation: {
    escapeValue: false,
    formatSeparator: ','
  },

  react: {
    useSuspense: true
  }
})

// Set the langauge when accessed first time.
let lang = Safety.get('language', 'xx')
const defaultLanguage = (window.navigator.language || 'en').split('-')[0]
if (lang === 'xx') {
  Safety.set('language', defaultLanguage)
  lang = defaultLanguage
}
i18next.changeLanguage(lang)

// After a deploy, keep the session but refresh what the previous build cached.
adoptSessionForNewBuild().catch(err => {
  console.error(err)
  Safety.clear()
}).finally(() => ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <>
    <I18nextProvider i18n={ i18next }>
      <AppProvider>
        <ThemeProvider>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </AppProvider>
    </I18nextProvider>
  </>
))
